module.exports = __webpack_public_path__ + "static/media/global-nav-v3.04e7a697.gif";